import { MembershipState } from "./MembershipState"

export enum MembershipActionType {
    ADD_MEMBERSHIP_DETAILS = `APP/MEMBERSHIP/ADD_MEMBERSHIP_DETAILS`,
    HAD_ERROR_SETTING_UP_UPFRONT_PAYMENT = `APP/MEMBERSHIP/HAD_ERROR_SETTING_UP_UPFRONT_PAYMENT`,
    REST_SETTING_UP_UPFRONT_PAYMENT_ERROR = `APP/MEMBERSHIP/REST_SETTING_UP_UPFRONT_PAYMENT_ERROR`,
}

export interface Action {
    type: MembershipActionType,
    value?: any,
}

export const initialState: MembershipState = {
    membershipDetails: undefined,
    hadErrorSettingUpUpfrontPaymentRetry: false,
}

export const membershipReducer = function (state: MembershipState = initialState, action: Action): MembershipState {
    switch (action.type) {
        case MembershipActionType.ADD_MEMBERSHIP_DETAILS:
            return {
                ...state,
                membershipDetails: action.value.membership,
            }
        case MembershipActionType.HAD_ERROR_SETTING_UP_UPFRONT_PAYMENT:
            return {
                ...state,
                hadErrorSettingUpUpfrontPaymentRetry: true,
            }
        case MembershipActionType.REST_SETTING_UP_UPFRONT_PAYMENT_ERROR:
            return {
                ...state,
                hadErrorSettingUpUpfrontPaymentRetry: false,
            }
    }
}
